var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('nav', {
    staticClass: "navigation d-none d-lg-flex container-fluid align-items-center justify-content-between",
    attrs: {
      "id": "main-navigation",
      "data-el": "navigation-bar"
    }
  }, [_c('ul', {
    staticClass: "d-flex text-center list-unstyled mb-0"
  }, _vm._l(_vm.navigation, function (navItem) {
    return _c('li', {
      key: navItem.id,
      staticClass: "px-3 vertical-line"
    }, [navItem.type === 'link' ? _c('MdmLink', {
      staticClass: "link-item d-block text-uppercase font-weight-semibold",
      style: {
        color: navItem.color
      },
      attrs: {
        "url": navItem.url,
        "data-title": navItem.label
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, {
            data: navItem.tracking
          });
        }
      }
    }, [_vm._v("\n        " + _vm._s(navItem.label) + "\n      ")]) : _c('span', {
      staticClass: "link-item d-block text-uppercase font-weight-semibold cursor-p",
      class: ['pr-4', {
        active: _vm.openedMenu === navItem.label
      }],
      style: {
        color: navItem.color
      },
      on: {
        "click": function click($event) {
          return _vm.handleClickNav(navItem);
        }
      }
    }, [_vm._v("\n        " + _vm._s(navItem.label) + "\n        "), _c('MdmIcon', {
      staticClass: "link-chevron",
      attrs: {
        "width": "20",
        "height": "20",
        "name": "chevron-down"
      }
    })], 1)], 1);
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "d-flex text-center list-unstyled mb-0"
  }, _vm._l(_vm.services, function (service) {
    return _c('li', {
      key: service.id,
      staticClass: "pl-4"
    }, [_c('MdmLink', {
      staticClass: "nav-right link-item font-weight-semibold",
      style: {
        color: service.color
      },
      attrs: {
        "url": service.url,
        "data-title": service.label
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, {
            data: service.tracking
          });
        }
      }
    }, [_vm._v("\n        " + _vm._s(service.label) + "\n      ")])], 1);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };